module.exports = __webpack_public_path__ + "img/one_archives.0e897183.png";